export interface Created {
  createdAt: string;
  createdBy: string;
}

export interface Deleted {
  deletedAt?: string;
  deletedBy?: string;
}

export interface Updated {
  updatedAt?: string;
  updatedBy?: string;
}

export interface Pagination {
  limit: number;
  offset: number;
  totalResults: number;
}

export interface IssuesSDKConfig {
  projectId: string;
  headers?: { [headerName: string]: string | string[] };
  useReactQuery?: boolean;
  returnQueryKey?: boolean;
}

export enum PermittedAction {
  Delete = "delete",
  Undelete = "undelete",
  Edit = "edit",
  CanEdit = "can_edit",
  AddComment = "add_comment",
  AddAttachment = "add_attachment",
  RemoveAttachment = "remove_attachment",
  ChangeOrder = "change_order",
  ClearAssignee = "clear_assignee",
  AssignAll = "assign_all",
  AssignSameCompany = "assign_same_company",
  Restore = "restore",
  UpsertPin = "upsert_pin",
  UnlinkPin = "unlink_pin",
  Copy = "copy",
}

export interface PaginatedResponse<T> {
  results: T[];
  pagination: Pagination;
}
